<template>
  <div class="locale-changer ma-2">
    <v-menu open-on-hover offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="px-1"
          rounded
          outlined
          small
          v-bind="attrs"
          v-on="on"
          color="white"
        >
          <strong class="ml-3" style="font-family: Poppins; font-weight: 700">
            {{ $i18n.locale.toUpperCase() }}
          </strong>
          <v-icon class="ml-3">mdi-web</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="(lang, index) in langs"
          :key="index"
          @click="setLocale(lang)"
        >
          <v-list-item-title>{{ lang.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'locale-changer',

  created() {
    this.$i18n.locale = localStorage.getItem('locale')
      ? localStorage.getItem('locale')
      : 'pt'
  },

  data() {
    return {
      langs: [
        { title: 'Português (Brasil)', value: 'pt' },
        { title: 'Espanhol', value: 'es' },
      ],
    }
  },

  methods: {
    setLocale(lang) {
      this.$i18n.locale = lang.value
      localStorage.removeItem('locale')
      localStorage.setItem('locale', this.$i18n.locale)
    },
  },
}
</script>
